import { Button } from '../button'

export default function PurchaseMade({ onClose, isDisabled, forBuyer }) {
  return (
    <div className='purchaseMade flex flexDirectionColumn alignCenter'>
      <h2>{forBuyer ? 'Thank you for your purchase!' : 'Congratulations'}</h2>
      <p className='description'>
        <span>
          {forBuyer
            ? 'We need a few seconds to complete a couple things for your purchase. The Continue button will light up for you to click when we’re ready to move along.'
            : 'Your vehicle has been Sold! We just need a minute to notify a consultant who will contact you with next steps. '}
        </span>
      </p>
      <div className='buttonsContainer flex justifyCenter'>
        <Button disabled={isDisabled && forBuyer} onClick={onClose}>
          {forBuyer ? 'Continue' : 'Close'}
        </Button>
      </div>

      <style jsx>{`
        .purchaseMade {
          justify-content: center;
          width: 100%;
          height: 100%;
        }

        h2 {
          text-align: center;
          font-size: 3.2rem;
        }

        .description {
          margin: 1.26rem 0 2.3rem;
          padding: 0 3rem;
          max-width: 50rem;
          width: 100%;
          text-align: center;
          font-size: 1.6rem;
        }

        .buttonsContainer {
          max-width: 39.8rem;
          width: 100%;
          margin: 2rem 0 0;

          :global(button) {
            width: 19.1rem;
            margin: 0 0.8rem;
          }
        }

        @media (max-width: 1024px) {
          .purchaseMade {
            justify-content: flex-start;
          }

          h2 {
            margin-top: 1.5rem;
            font-size: 1.8rem;
          }

          .description {
            margin: 0.5rem 0 1rem;
            font-size: 1.4rem;
          }

          .buttonsContainer {
            position: fixed;
            left: 0;
            bottom: 2.1rem;
            z-index: 1;
            width: 100%;
            margin: 0;
            padding: 0 1.3rem;

            :global(button) {
              width: 100%;
            }
          }
        }
      `}</style>
    </div>
  )
}
